<!--付款信息-->
<template>
  <div class="payment-info-container">
    <div class="payment-info-content">
      <div class="payment-row" v-if="state==0||state==1||state==2||state==6 || state==5">
        <label>商品总价：</label>
        <span>￥{{ parseFloat(data.goodsTotal).toFixed(2) }}</span>
      </div>
      <div class="payment-row" v-if="state==0||state==1||state==2||state==6 || state==5">
        <label>优惠券：</label>
        <span v-if="data.preferentialAmount>0" class="red-span">
          -￥{{ parseFloat(data.preferentialAmount).toFixed(2) }}
          <i class="el-icon-arrow-right"></i>
        </span>
        <span v-else class="red-span">-￥0</span>
      </div>
      <div class="payment-row" style="padding-bottom: 40px;" v-if="state==0||state==1||state==2||state==6 || state==5">
        <label>应付款：</label>
        <span class="red-span SourceHanSansCN">-￥{{ parseFloat(data.total).toFixed(2) }}</span>
      </div>
      <div class="button-box" v-if="state == 0">
        <el-button type="danger" @click="payImmediately(data)">立即支付</el-button>
        <el-button type="info" plain @click="cancelOrders(data)">取消订单</el-button>
      </div>
      <div class="button-box" v-if="state == 1">
        <el-button type="danger" @click="applyRefund(data)">申请售后</el-button>
        <el-button type="info" plain @click="remindShipping(data)">提醒服务</el-button>
      </div>
      <div class="button-box" v-if="state == 6">
        <el-button type="danger" @click="confirmCompletion(data)">确定完成</el-button>
        <el-button type="info" plain @click="applyAfterSales(data)">申请售后</el-button>
      </div>
      <div class="button-box" v-if="state == 2 || state == 3">
        <el-button type="danger" v-if="state!==3" @click="dialogVisible = true">去评价</el-button>
        <el-button type="danger" v-if="state==3" @click="productDetails">重新购买</el-button>
        <el-button type="danger" @click="deleteOrders(data)" v-if="state==3">删除订单</el-button>
        <el-button type="info" plain @click="ContactCustomer">客服服务</el-button>
      </div>
      <div class="button-box" v-if="state == -2">
        <el-button type="danger" @click="updateApplyRefund(data)">重新修改</el-button>
        <el-button type="info" plain @click="revokeApplication(data)">撤销申请</el-button>
      </div>
      <!--商家拒绝退款退货-->
      <div class="button-box" v-if="state == -4">
        <el-button type="danger" @click="updateApplyRefund(data)">重新提交</el-button>
        <el-button type="info" plain @click="revokeApplication(data)">撤销申请</el-button>
        <el-button type="info" plain @click="ContactCustomer">客服服务</el-button>
      </div>
      <div class="button-box" v-if="state == 7">
        <el-button type="danger" @click="productDetails">重新购买</el-button>
      </div>
      <div class="button-box" v-if="state == 5">
        <!--<el-button type="danger" @click="productDetails">重新购买</el-button>-->
        <el-button type="danger" @click="deleteOrders(data)">删除订单</el-button>
      </div>
    </div>
    <el-dialog title="评价" :visible.sync="dialogVisible" width="30%" top="60px" :lock-scroll="true"
               class="evaluateDialog">
      <el-form :model="evaluate" ref="evaluateForm" class="evaluateForm">
        <el-form-item label="综合评分" class="rate-form">
          <el-rate v-model="evaluate.comprehensive" :colors="['#FE273B', '#FE273B', '#FE273B']"/>
        </el-form-item>
        <el-form-item>
          <el-input type="textarea" :rows="9" maxlength="300" show-word-limit placeholder="请评价下您对服务的感受吧"
                    v-model="evaluate.content"/>
        </el-form-item>
        <el-form-item>
          <p style="margin-block-start: 0px;margin-block-end: 0px;color: #666666;">最多上传9张</p>
          <el-upload action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg" :limit="9"
                     ref="upload"
                     list-type="picture-card" :file-list="fileList" :on-exceed="handleExceed" :multiple="true"
                     :on-success="successUpload" accept=".png,.jpeg,.jpg" :on-preview="handlePictureCardPreview"
                     :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="专业程度" class="rate-form">
          <el-rate v-model="evaluate.level" :colors="['#FE273B', '#FE273B', '#FE273B']"/>
        </el-form-item>
        <el-form-item label="办理时间" class="rate-form">
          <el-rate v-model="evaluate.handTime" :colors="['#FE273B', '#FE273B', '#FE273B']"/>
        </el-form-item>
        <el-form-item label="服务态度" class="rate-form">
          <el-rate v-model="evaluate.attitude" :colors="['#FE273B', '#FE273B', '#FE273B']"/>
        </el-form-item>
        <el-form-item style="text-align: center;">
          <el-button type="danger" @click="submitEvaluate">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" title="图片预览" width="550px">
      <el-image :src="dialogImageUrl" style="width: 500px;height: auto"/>
    </el-dialog>
  </div>
</template>

<script>
import {
  cannalByIdOrders,
  deletOrdersById,
  cancelRefund,
  buyerReminderShipmentOrService,
  evaluateMangement,
  confirmCompletedOrder
} from '@/api/orderApi'

export default {
  name: "paymentInfo",
  data() {
    return {
      dialogVisible: false,
      evaluate: {
        content: '',
        img: [],
        level: null,
        attitude: null,
        handTime: null,
        comprehensive: null
      },
      fileList: [],
      dialogImageUrl: '',
      dialogVisible2: false,
      cid: 0,
    }
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    state: {
      type: Number,
      default() {
        return 0
      }
    },
  },
  methods: {
    /*申请退款*/
    applyAfterSales(data) {
      this.$router.push({
        path: "/orderManagement/applyAfterSales",
        query: {state: data.state, id: data.id},
      })
    },
    /*未发货申请退款*/
    applyRefund(data) {
      this.$router.push({
        path: "/orderManagement/applyAfterSales",
        query: {state: data.state, id: data.id},
      })
    },
    /*编辑申请*/
    updateApplyRefund(data) {
      this.$router.push({
        path: "/orderManagement/applyAfterSales",
        query: {state: data.state, id: this.$route.query.id},
      })
    },
    /*图片在线预览*/
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },
    /*检索上传数量，限制上传3张*/
    handleExceed(files, fileList) {
      this.$message.error(`已超过上传上限！`);
    },
    /*上传图片成功处理*/
    successUpload(response, file, fileList) {
      this.evaluate.img.push(response.imgPath);
    },
    /*图片删除*/
    handleRemove(file, fileList) {
      for (let i in this.evaluate.img) {
        if (this.evaluate.img[i] == file.response.imgPath) {
          this.evaluate.img.splice(i, 1)
        }
      }
    },
    /*取消订单*/
    cancelOrders(rows) {
      this.$confirm('您确定要取消吗？', '提示', {confirmButtonText: '确定', cancelButtonText: '取消'}).then(() => {
        cannalByIdOrders({cid: rows.uid, id: rows.id, order_num: rows.orderNum}).then(res => {
          if (res.code == 200) {
            this.$message.success('取消订单成功！');
            this.$emit('getOrderDetails');
          } else {
            this.$message.error('操作失败！');
          }
        })
      }).catch(() => {
      });
    },
    /*刷新订单*/
    refreshOrder() {
      this.$emit('getOrderDetails');
    },
    /*删除订单*/
    deleteOrders(rows) {
      this.$confirm('是否删除订单?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消'}).then(() => {
        deletOrdersById({id: rows.id, request: 'form', uid: rows.uid}).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功！');
            this.$router.back(-1);
          } else {
            this.$message.error('删除失败！');
          }
        })
      }).catch(() => {
      });
    },
    /*撤销申请*/
    revokeApplication(data) {
      this.$confirm('确定要撤销退款申请吗？', '提示', {confirmButtonText: '确定', cancelButtonText: '取消'}).then(() => {
        cancelRefund({cid: this.cid, id: this.$route.query.id, uid: this.cid}).then(res => {
          if (res.code == 200) {
            this.$message.success('撤销成功！');
            this.$emit('getOrderDetails');
          } else {
            this.$message.error(res.esg);
          }
        })
      }).catch(() => {
      });
    },
    /*提醒发货*/
    remindShipping() {
      buyerReminderShipmentOrService({orderId: this.$route.query.id, uid: this.cid}).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /*提交追加评论*/
    submitEvaluate() {
      if (!this.evaluate.level) {
        this.$message('请对专业程度进行评分')
        return
      }
      if (!this.evaluate.handTime) {
        this.$message('请对办理时间进行评分')
        return
      }
      if (!this.evaluate.attitude) {
        this.$message('请对服务态度进行评分')
        return
      }
      if (!this.evaluate.comprehensive) {
        this.$message('请对此次服务进行综合评分')
        return
      }
      evaluateMangement({
        anonymous_status: 0,/*是否匿名*/
        cid: this.cid,/*用户id*/
        comprehensive_score: this.evaluate.comprehensive,/*综合评分*/
        goodsid: this.data.goodsId,/*商品id*/
        img: this.evaluate.img.join(','),/*图片地址*/
        order_id: this.$route.query.id,/*订单id*/
        processsing_time: this.evaluate.handTime,/*办理时间评价*/
        professional_score: this.evaluate.level,/*专业程度评价*/
        service_attitude: this.evaluate.attitude,/*服务态度评价*/
        text: this.evaluate.content,/*评价内容*/
      }).then(res => {
        if (res.code == 200) {
          this.$message.success('追加评论成功。');
          this.dialogVisible = false;
          this.$emit('getOrderDetails');
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /*确定完成*/
    confirmCompletion(data) {
      this.$confirm('确定服务已完成？', '提示', {confirmButtonText: '确定', cancelButtonText: '取消'}).then(() => {
        confirmCompletedOrder({cid: this.cid, id: this.$route.query.id, order_num: data.orderNum}).then(res => {
          if (res.code == 200) {
            this.$message.success('服务已完成。');
            this.$emit('getOrderDetails');
          } else {
            this.$message.error('操作失败！');
          }
        })
      }).catch(() => {
      });
    },
    /*立即支付*/
    payImmediately(data) {
      this.$router.push({
        path: '/payment/payCheck',
        query:{id: data.id, ordernum: data.orderNum,price:JSON.stringify(data.total)}
      })
    },
    /*联系客服*/
    ContactCustomer(){
      let routeData = this.$router.resolve({
        name: "onlineService",
        path: '/onlineService/index',
        query:{
          id:this.data.shopId
        }
      });
      window.open(routeData.href, '_blank')
    },
    /*商品详情*/
    productDetails(){
      this.$router.push({
        path: '/cloudPlatform/productDetails',
        query: {
          id: this.data.id,
          nextName:'订单管理'
        },
      })
    },
  },
  beforeMount() {
    this.cid = JSON.parse(sessionStorage.getItem('loginData')).cid;
  }
}
</script>

<style scoped>
.payment-info-container >>> .payment-info-content .button-box .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 20px;
  border-radius: 0px;
}

.payment-info-container >>> .payment-info-content .button-box .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}

.payment-info-container >>> .payment-info-content .button-box .el-button--info.is-plain {
  padding: 10px 20px;
  background: #F1F1F1;
  border: 1px solid #F1F1F1;
  border-radius: 0px;
  color: #333333;
}

.payment-info-container >>> .payment-info-content .button-box .el-button--info.is-plain:hover {
  background: #ffffff;
  border: 1px solid #DDDDDD;
  color: #999999;
}

.evaluateDialog >>> .el-rate__icon {
  font-size: 22px;
  margin-right: 5px;
}

.evaluateDialog >>> .el-form-item {
  margin-bottom: 10px;
}

/* 设置dialog弹出框的样式 */
.evaluateDialog >>> .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 10px 10px 0px 0px;
  vertical-align: middle;
}

/* 弹出框标题字体 */
.evaluateDialog >>> .el-dialog__title {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #222222;
}

/* 叉叉设置 */
.evaluateDialog >>> .el-dialog__headerbtn {
  top: 20px;
  font-size: 24px;
}

.evaluateDialog >>> .el-dialog__body {
  padding: 20px 20px 40px 20px;
}

.evaluateDialog >>> .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 50px;
}

.evaluateDialog >>> .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}

.evaluateDialog >>> .el-upload-list--picture-card .el-upload-list__item {
  border: 1px solid #c0ccda;
  border-radius: 6px;
  width: 95px;
  height: 95px;
}

.evaluateDialog >>> .el-upload--picture-card {
  background-color: #ffffff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  width: 95px;
  height: 95px;
  line-height: 100px;
}

.evaluateDialog >>> .el-textarea .el-input__count {
  color: #AAAAAA;
  background: center;
  font-size: 14px;
  bottom: -5px;
}
</style>
<style scoped lang="scss">
.payment-info-container {
  .payment-info-content {
    text-align: -webkit-right;

    .payment-row {
      width: 250px;
      display: flex;
      justify-content: space-between;
      cursor: context-menu;
      line-height: 25px;

      label {
        width: 80px;
      }

      .red-span {
        color: #FE273B;
      }

      .el-icon-arrow-right {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }

  .rate-form {
    display: flex;
    align-items: center;
  }
}
</style>